"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[3132],{

/***/ 73132:
/***/ ((module) => {

module.exports = JSON.parse('{"saved":"Sparat","userUpdatedText":"{name} är nu uppdaterad"}');

/***/ })

}]);